/** Campaigns overview page strings (PREC-3880; own file — en.ts is at the size ratchet). */
export const enCampaignsOverview = {
	searchPlaceholder: "Search campaigns and lists...",
	newCampaign: "New Campaign",
	empty: "No campaigns match these filters.",
	loadError: "The campaigns could not be loaded. Reload the page to try again.",
	archiveConfirmation: "Archive the list “{{name}}”? Its campaigns stop sending.",
	tabs: {
		mine: "My campaigns",
		team: "Team campaigns",
		all: "All campaigns",
	},
	stats: {
		running: "Running campaigns",
		runningDetail: "of {{total}} total · {{lists}} lists",
		contacted: "Contacted",
		contactedDetail: "prospects",
		replied: "Replied",
		repliedDetail: "{{rate}}% reply rate",
		positive: "Positive",
		positiveDetail: "{{rate}}% of contacted",
	},
	statusFilter: {
		ALL: "All campaigns",
		RUNNING: "Running",
		PAUSED: "Paused",
		ENDED: "Ended",
		DRAFT: "Draft",
		INVALID: "Invalid",
	},
	channelFilter: {
		label: "Channel",
		ALL: "All",
		EMAIL: "Email",
		LINKEDIN: "LinkedIn",
	},
	channels: {
		email: "Email",
		linkedin: "LinkedIn",
	},
	countPill: {
		label_one: "{{count}} campaign",
		label_other: "{{count}} campaigns",
		running: "{{running}} of {{count}} running",
		none: "No running campaigns",
	},
	rowMenu: {
		openCampaign: "Open campaign",
		pause: "Pause",
		resume: "Resume",
		duplicate: "Duplicate",
		openList: "Open lead list",
		newCampaignForList: "New campaign for this list",
		archiveList: "Archive list",
	},
	newCampaignModal: {
		title: "New campaign",
		note: "A campaign always belongs to one lead list. Pick the list it should run on, or create a new list first.",
		pickerTitle: "Choose a lead list",
		pickerNote:
			"The campaign will only reach prospects on the list you choose here. You can\u2019t move it later.",
		cardExisting: {
			title: "Create campaign for an existing list",
			description:
				"Add another campaign to a list you already built. Best when you want a second channel, language or follow-up angle.",
		},
		cardNewList: {
			title: "Create new list & campaign",
			description: "Start with a fresh lead list, then set up its first campaign.",
		},
		searchPlaceholder: "Search lead lists...",
		noneFound: "No lists found.",
		meta_one: "{{prospects}} prospects \u00b7 {{count}} campaign",
		meta_other: "{{prospects}} prospects \u00b7 {{count}} campaigns",
		hintNone: "No list selected",
		hintSelected: "Campaign will run on {{name}}",
		continue: "Continue",
	},
	// Campaigns-specific pin-to-tab criteria labels; the shared strings live under `list.pinTab.*`.
	pinTab: {
		criteria: {
			status: "Status",
			channel: "Channel",
		},
	},
	bulk: {
		selected_one: "{{count}} campaign selected",
		selected_other: "{{count}} campaigns selected",
		clear: "Clear selection",
		resume: "Resume",
		pause: "Pause",
		duplicate: "Duplicate",
	},
};
